<div *ngIf="toPublishMediaClips && toPublishMediaClips.length > 0" >
	<bb-table-container>
		<bb-table-header>
			<bb-table-header-cell class="thumb"></bb-table-header-cell>
			<bb-table-header-cell class="icon"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status">{{ 'STATUS' | translate }}</bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell class="thumb">
				<bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
			</bb-table-cell>
			<bb-table-cell><span style="white-space: no-break;"><span [innerHTML]="row.data | clipIcon"></span><strong [hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;" title="Creative">C</strong></span></bb-table-cell>
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">
				<span [hidden]="!row.data.title">{{ row.data.title }}</span>
				<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
				
			</bb-table-cell>
			<bb-table-cell property="status" *ngIf="row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="(row.data | statusIcon) + (row.data | bbStreamStatusIcon | async)" class="stream-status-icon"></span></bb-table-cell>
			<bb-table-cell property="status" *ngIf="!row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager></bb-table-pager>
	
	<div class="buttons">
		<bb-button (click)="cancelPublish()">
			{{ 'CANCEL' | translate }}
		</bb-button>
		
		<bb-button (click)="publishAsIs()">
			{{ 'PUBLISH_AS_IS' | translate }}
		</bb-button>
		
		<bb-button (click)="publishAllDraftClips()">
			{{ 'PUBLISH_ALL' | translate }}
		</bb-button>
	</div>
</div>